import { render, staticRenderFns } from "./ProjectBrowse.vue?vue&type=template&id=2c7d7243"
import script from "./ProjectBrowse.vue?vue&type=script&lang=ts"
export * from "./ProjectBrowse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c7d7243')) {
      api.createRecord('2c7d7243', component.options)
    } else {
      api.reload('2c7d7243', component.options)
    }
    module.hot.accept("./ProjectBrowse.vue?vue&type=template&id=2c7d7243", function () {
      api.rerender('2c7d7243', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/project/ProjectBrowse.vue"
export default component.exports